/**
 * Reads the API's error envelope for the text creation flow: the machine code and
 * its extra fields (`max_chars`, `forms`, `spans`, `refresh_at` …). Messages are
 * chosen from the code, never from the English `detail` text (the same rule as
 * fileUploadErrorMessage).
 */
type Envelope = { code?: unknown; [key: string]: unknown }

export function apiErrorDetail(err: unknown): Envelope | null {
  const detail = (err as { response?: { data?: { detail?: unknown } } } | null)?.response?.data?.detail
  return detail && typeof detail === 'object' ? (detail as Envelope) : null
}

export function apiErrorCode(err: unknown): string | null {
  const code = apiErrorDetail(err)?.code
  return typeof code === 'string' ? code : null
}

/** The request never got an answer: a dropped connection, not a refusal. */
export function isNetworkError(err: unknown): boolean {
  return !(err as { response?: unknown } | null)?.response
}
